import React from "react";
import { Helmet } from "react-helmet";

export const ThinkResultPixel = () => {
    return (
            <Helmet>
                <script>
                {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://urldefense.com/v3/__https://connect.facebook.net/en_US/fbevents.js__;!!N96JrnIq8IfO5w!m0IWFEl2y0nb4VtDS6F1eGvoLD_RgSlW8oSGX4Q_xuP2IBeDzBkXhV2LxlaJoDHrECw7jmtReHaOxINiuSxJfEDFXXuBEUeVs0Tz$ ');
fbq('init', '5504368349599740');
fbq('track', 'PageView');`}
                </script>
            </Helmet>
        );
}

export const CallThinkResultOnThankYouPage = () => {
    window.fbq('trackSingle', '5504368349599740', 'SubmitApplication');
}
